// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/CodesAdmin`
  | `/auth/confirm`
  | `/codes-admin`
  | `/password-reset`
  | `/report`
  | `/report/:id`
  | `/report/:id/edit/address`
  | `/report/:id/edit/mileage`
  | `/report/:id/edit/period`
  | `/report/:id/edit/work-schedule`
  | `/report/:id/pdf`
  | `/report/create/address`
  | `/report/create/generating`
  | `/report/create/mileage`
  | `/report/create/period`
  | `/report/create/profession`
  | `/stripe-return`

export type Params = {
  '/report/:id': { id: string }
  '/report/:id/edit/address': { id: string }
  '/report/:id/edit/mileage': { id: string }
  '/report/:id/edit/period': { id: string }
  '/report/:id/edit/work-schedule': { id: string }
  '/report/:id/pdf': { id: string }
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
